<template>
<div>
<div class="p-section ctt-cnt aos-init aos-animate" data-aos="fade-up" data-aos-duration="1800">
        <form action="" method="post" id="form" name="myform" novalidate="novalidate">
            <div class="tbl">
                <p class="p-category-title">お申込</p>
                <h4 class="p-page-title" style="margin-bottom: 1rem">Entry</h4>
                <p style="margin-bottom: 5rem">{{ hpConfig.entry_servies[serviceId].name }}のお申込</p>
                <hr>
                <div v-if="serviceId == 1">
                    <div class="tbl-row">
                        <div class="tbl-col pls-mail">
                            診断対象サービスURL
                        </div>
                        <div class="tbl-col pls-mail">
                            <div class="hinfo">必須</div>
                        </div>
                        <div class="tbl-col pls-mail">
                            <input type="text" name="target_url" class="col-two" placeholder="https://www.ranryu.co.jp" required="">
                        </div>
                    </div>
                    <hr>
                    <div class="tbl-row">
                        <div class="tbl-col pls-mail">
                            診断対象サービスで利用している<p>サーバのIPアドレス</p>
                        </div>
                        <div class="tbl-col pls-mail">
                            <input type="text" name="target_ip" class="col-two" placeholder="" required="" style="ime-mode: inactive">
                        </div>
                    </div>
                    <hr>
                    <div class="tbl-row">
                        <div class="tbl-col pls-mail">
                            診断対象サービスのサービス内容
                            <p style="color: #BABECB; font-size: 1.2rem">必要時応じて弊社からサービス内容を確認させていただく場合がございます</p>
                        </div>
                        <div class="tbl-col pls-mail">
                            <div class="hinfo">必須</div>
                        </div>
                        <div class="tbl-col pls-mail">
                            <textarea rows="10" name="target_serice_overview"></textarea>
                        </div>
                    </div>
                    <hr>
                    <div class="tbl-row">
                        <div class="tbl-col pls-mail">
                            サービス利用が多い時間帯
                            <p style="color: #BABECB; font-size: 1.2rem">24時間表記</p>
                        </div>
                        <div class="tbl-col pls-mail">
                            <div class="custom-timepicker"><vue-timepicker format="HH" hour-label="時" close-on-complete placeholder="開始時間" name="busy_time_start" class="timepicker"></vue-timepicker></div>
                            &nbsp;〜&nbsp;<vue-timepicker format="HH" hour-label="時" close-on-complete placeholder="終了時間" name="busy_time_end" class="timepicker"></vue-timepicker><br>

                        </div>
                    </div>
                    <hr>
                    <div class="tbl-row">
                        <div class="tbl-col pls-mail">
                            サービス利用が多い時間帯の合計PV数
                            <p style="color: #BABECB; font-size: 1.2rem">診断時のアクセス間隔の参考値とさせていただきます。</p>
                        </div>
                        <div class="tbl-col pls-mail">
                            <input type="text" name="max_pv"  style="width: 12%" placeholder="10000" required="">
                        </div>
                    </div>
                    <hr>
                    <div class="tbl-row">
                        <div class="tbl-col pls-mail">
                            診断実施の候補日および時間帯
                            <p style="color: #BABECB; font-size: 1.2rem">診断は、診断可能な時間により、数日必要となる場合がございます。</p>
                        </div>
                        <div class="tbl-col pls-mail">
                            <div class="hinfo">必須</div>
                        </div>
                        <div class="tbl-col pls-mail">
                            第一希望<br><datepicker style="width: 14%" class="datepicker" placeholder="日付を選択" :language="ja" :format="datePickerFormat" name="test_date_1"></datepicker>
                            &nbsp;:&nbsp;<div class="custom-timepicker"><vue-timepicker format="HH" hour-label="時" close-on-complete placeholder="開始時間" name="test_time_start_1" class="timepicker"></vue-timepicker></div>
                            &nbsp;〜&nbsp;<vue-timepicker format="HH" hour-label="時" close-on-complete placeholder="終了時間" name="test_time_end_2" class="timepicker"></vue-timepicker><br>
                            第二希望<br><datepicker style="width: 14%" class="datepicker" placeholder="日付を選択" :language="ja" :format="datePickerFormat" name="test_date_2"></datepicker>
                            &nbsp;:&nbsp;<div class="custom-timepicker"><vue-timepicker format="HH" hour-label="時" close-on-complete placeholder="開始時間" name="test_time_start_2" class="timepicker"></vue-timepicker></div>
                            &nbsp;〜&nbsp;<vue-timepicker format="HH" hour-label="時" close-on-complete placeholder="終了時間" name="test_time_end_2" class="timepicker"></vue-timepicker><br>
                            第三希望<br><datepicker style="width: 14%" class="datepicker" placeholder="日付を選択" :language="ja" :format="datePickerFormat" name="test_date_3"></datepicker>
                            &nbsp;:&nbsp;<div class="custom-timepicker"><vue-timepicker format="HH" hour-label="時" close-on-complete placeholder="開始時間" name="test_time_start_3" class="timepicker"></vue-timepicker></div>
                            &nbsp;〜&nbsp;<vue-timepicker format="HH" hour-label="時" close-on-complete placeholder="終了時間" name="test_time_end_2" class="timepicker"></vue-timepicker><br>
                        </div>
                    </div>
                    <hr>
                    <div class="tbl-row">
                        <div class="tbl-col pls-mail">
                            サービスへの管理アクセスに資格情報が必要な場合、ログインURL、アカウント、パスワードをご提示ください
                        </div>
                        <div class="tbl-col pls-mail">
                            <input type="text" name="login_url"  style="width: 51%" placeholder="ログインURL" required=""><br>
                            <div id="spacer" style="height: 10px"></div>
                            <input type="text" name="login_id"  style="width: 51%" placeholder="ID" required=""><br>
                            <div id="spacer" style="height: 10px"></div>
                            <input type="password" name="login_pw"  style="width: 51%" placeholder="パスワード" required="">
                        </div>
                    </div>
                    <hr>
                    <div class="tbl-row">
                        <div class="tbl-col pls-mail">
                            ご希望の診断内容
                        </div>
                        <div class="tbl-col pls-mail">
                            <div class="hinfo">必須</div>
                        </div>
                        <div class="tbl-col pls-mail">
                            <input type="radio" name="check_type" value="1" v-on:change="changeCheckType" checked>Level1・・・自動診断だけ実施する<br>
                            <input type="radio" name="check_type" value="2" v-on:change="changeCheckType">Level2・・・自動診断、手動診断を実施する
                        </div>
                    </div>
                    <div v-if="checkType == 2">
                    <hr>
                    <div class="tbl-row">
                        <div class="tbl-col pls-mail">
                            別途、以下のインフラ構成がわかる情報をご提供ください
                            <p style="color: #BABECB; font-size: 1.2rem; margin-bottom: 0">・サーバーインフラ状況<br>（物理サーバー、クラウドサーバ、VPS等）</p>
                            <p style="color: #BABECB; font-size: 1.2rem; margin-bottom: 0">・サーバー台数</p>
                            <p style="color: #BABECB; font-size: 1.2rem; margin-bottom: 0">・サーバーアクセス方法</p>
                            <p style="color: #BABECB; font-size: 1.2rem; margin-bottom: 0">・サーバーミドルウェア</p>
                            <p style="color: #BABECB; font-size: 1.2rem; margin-bottom: 0">・サーバーログイン情報/データベースログイン情報</p>
                        </div>
                        <div class="tbl-col pls-mail">
                            <div class="hinfo">必須</div>
                        </div>
                        <div class="tbl-col pls-mail">
                            <textarea rows="10" name="server_env"></textarea>
                        </div>
                    </div>
                    </div>
                    <hr>
                    <div class="tbl-row">
                        <div class="tbl-col pls-mail">
                            オプションサービスにて実施をしております。ご希望の場合は選択してください
                        </div>
                        <div class="tbl-col pls-mail">
                            <input type="radio" name="option_value" value="1">診断結果に関する報告会の実施（リモートでお打ち合わせを実施し、診断結果を報告させていただきます）<br>
                        </div>
                    </div>
                    <hr>
                    <div class="tbl-row">
                        <div class="tbl-col pls-mail">
                            本サービスに関するご質問事項等がございましたらご記入ください
                        </div>
                        <div class="tbl-col pls-mail">
                            <textarea rows="10" name="question"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 共通入力項目 -->
            <CommonEntryFormInput />
        </form>
  </div>
</div>
</template>
<script>
import CommonEntryFormInput from '@/components/CommonEntryFormInput'
import CommonMixin from '@/mixins'
import Datepicker from 'vuejs-datepicker'
import {ja} from 'vuejs-datepicker/dist/locale'
import VueTimepicker from 'vue2-timepicker/src'

export default {
  mixins: [CommonMixin],
  name: 'EntryInput',
  data () {
    return {
      categories: [
      ],
      serviceId: 0,
      ja: ja,
      datePickerFormat: 'yyyy-MM-dd',
      checkType: 1
    }
  },
  methods: {
    changeCheckType: function (event) {
      this.checkType = event.target.value
    }
  },
  components: {CommonEntryFormInput, Datepicker, 'vue-timepicker': VueTimepicker},
  mounted: function () {
    if (this.contactIsFinish) {
      this.$router.push('/')
    }
    this.serviceId = (this.$route.query.id) ? this.$route.query.id : 1
  }
}
</script>
<style scoped>
.pls-mail {
    text-align: left;
}
.cat-element {
    cursor: pointer;
}
.index_area {
    cursor: pointer;
}
.check {
display: none;
}
.index_area:before {
  content: "arrow_right";
  font-family: "Material Icons";
  font-size: 20px;
  position: absolute;
  transform: translateY(-14%);
}
.contact_img {
    width: 20%;
}
@media screen and (max-width:768px) {
    .contact_img {
        width: 40%;
    }
}
.sugg_content {
    margin-top: -50px
}
@media screen and (max-width:768px) {
    .sugg_content {
        margin-top: -20px
    }
}
.select_item {
    height: 3.6rem;
    background-color: #F7F8FA;
    border-radius: 4px;
    padding: 1rem;
}
.datepicker {
    display: inline-block; _display: inline;
}
.vdp-datepicker >>> .vdp-datepicker__calendar .cell.selected{
    color: white;
    background: black;
}
.vdp-datepicker >>> .vdp-datepicker__calendar .cell.hover{
    color: white;
    background: black;
}
.vdp-datepicker >>> .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover {
    border: 1px solid black;
}
.timepicker {
    font-size: 1.4rem;
    width: 100px;
}
.custom-timepicker {
    display: inline-block; _display: inline;
}
.custom-timepicker >>> .vue__time-picker .dropdown ul li:not([disabled]).active,
.custom-timepicker >>> .vue__time-picker .dropdown ul li:not([disabled]).active:focus,
.custom-timepicker >>> .vue__time-picker .dropdown ul li:not([disabled]).active:hover {
    background: black;
}
.ctt-cnt form .tbl .tbl-col input[type="password"] {
    height: 3.6em;
    background-color: #F7F8FA;
    border: solid 1px #C5C5C5;
    border-radius: 4px;
    padding: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/EntryInput.vue